import styled from "styled-components";

export const StyledContent = styled.div`
  display: flex;
  align-items: baseline;
  padding: 15px 20px;
`;

export const labelStyles = {
  root: {
    width: "150px",
    fontSize: "16px",
    fontWeight: "bold",
    color: "black",
  },
};

export const ButtonContainer = styled(StyledContent)`
  text-align: left;
  gap: 20px;
`;

export const StyledContainer = styled.div`
  color: #b2b2b2;
  font-weight: 800;
  font-size: 18px;
  transition: 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;
